import { createRootLocationForOtherConsumer, createRootLocationForPrimaryConsumer, createSearchParams, getConsumerPath, serializeSearchParams, } from '@feature-hub/history-service';
import * as history from 'history';
const consumerPathsQueryParamName = '---';
export function splitUrlInBaseAndPrimaryConsumer(path) {
    const splitPathname = path.split(':');
    return {
        primaryPathname: splitPathname && splitPathname[1] ? splitPathname[1] : '/',
        rootPathname: splitPathname && splitPathname[0] ? splitPathname[0] : '/',
    };
}
export function createRootLocationTransformer(integratorId, primaryConsumerId) {
    return {
        createRootLocation: (currentRootLocation, consumerLocation, historyKey) => {
            if (historyKey === integratorId) {
                return Object.assign(Object.assign({}, consumerLocation), { hash: currentRootLocation.hash });
            }
            const splitPathname = splitUrlInBaseAndPrimaryConsumer(currentRootLocation.pathname || '');
            const consumerRootLocation = {
                hash: currentRootLocation.hash,
                pathname: splitPathname.primaryPathname,
                search: currentRootLocation.search,
            };
            const isPrimaryConsumer = primaryConsumerId === historyKey;
            let newRootLocation;
            if (isPrimaryConsumer) {
                newRootLocation = createRootLocationForPrimaryConsumer(consumerRootLocation, consumerLocation, consumerPathsQueryParamName);
            }
            else {
                newRootLocation = createRootLocationForOtherConsumer(consumerRootLocation, consumerLocation, historyKey, consumerPathsQueryParamName);
            }
            return Object.assign(Object.assign({}, newRootLocation), { pathname: splitPathname.rootPathname +
                    (newRootLocation.pathname !== '/'
                        ? `:${newRootLocation.pathname}`
                        : '') });
        },
        getConsumerPathFromRootLocation: (rootLocation, historyKey) => {
            const splitPathname = splitUrlInBaseAndPrimaryConsumer(rootLocation.pathname || '');
            if (historyKey === integratorId) {
                return history.createPath({
                    hash: undefined,
                    pathname: splitPathname.rootPathname,
                    search: rootLocation.search,
                });
            }
            const newLocation = {
                hash: rootLocation.hash,
                pathname: splitPathname.primaryPathname,
                search: rootLocation.search,
            };
            const isPrimaryConsumer = primaryConsumerId === historyKey;
            const searchParams = createSearchParams(newLocation);
            if (isPrimaryConsumer) {
                searchParams.delete(consumerPathsQueryParamName);
                const { pathname, hash } = newLocation;
                const search = serializeSearchParams(searchParams);
                return history.createPath({
                    hash,
                    pathname,
                    search,
                });
            }
            const consumerPaths = searchParams.get(consumerPathsQueryParamName);
            if (!consumerPaths) {
                return '/';
            }
            return getConsumerPath(consumerPaths, historyKey) || '/';
        },
    };
}
//# sourceMappingURL=history-service-transformer.js.map